export default {
  title: 'Datum & Uhrzeit',
  buttons: {
    done: 'Fertig',
  },
};
